import {useEvent} from 'Event/EventProvider'
import RedirectErrorMessage from 'Event/Obie/RedirectErrorMessage'
import FullPageLoader from 'lib/ui/layout/FullPageLoader'
import {api, useQueryParams} from 'lib/url'
import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'

export default function ObieRedirect() {
  const {event, client} = useEvent()
  const queryParams = useQueryParams()
  const {attendee_link_slug: attendeeLinkSlug} = useParams<{
    attendee_link_slug?: string
  }>()
  const [attempt, setAttempt] = useState(0)
  const [error, setError] = useState<{status?: number} | null>(null)

  useEffect(() => {
    let mounted = true
    setError(null)

    client
      .post<{url: string}>(api(`/events/${event.id}/obie`), {
        attendee_link_slug: attendeeLinkSlug ?? null,
      })
      .then((destination) => {
        if (!mounted) {
          return
        }

        // Obvio puts the attendee's identity on the returned URL, so a
        // parameter on the link never replaces one already there.
        const url = new URL(destination.url)
        for (const [key, value] of Object.entries(queryParams)) {
          if (url.searchParams.has(key)) {
            continue
          }

          url.searchParams.append(key, value ?? '')
        }

        window.location.href = url.href
      })
      .catch((e) => {
        if (!mounted) {
          return
        }

        setError(e)
      })

    return () => {
      mounted = false
    }
  }, [client, event.id, queryParams, attendeeLinkSlug, attempt])

  if (error) {
    return (
      <RedirectErrorMessage
        status={error.status}
        onRetry={() => setAttempt((current) => current + 1)}
      />
    )
  }

  return <FullPageLoader />
}
